import { FC } from 'react';
import s from './currency.module.scss';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import { ValueTypes } from '@specs/specs';
import { formatRubyAmount, formatWithSpaces } from '@specs/helpers';
import cn from 'classnames';
interface Props {
  currency: ValueTypes;
  amount: number;
}
export const Currency: FC<Props> = ({
  currency,
  amount
}) => {
  const currentPrice = currency === 'RUBY' ? formatRubyAmount(amount) : amount;
  return <div className={cn(s.currency)} data-sentry-component="Currency" data-sentry-source-file="Currency.tsx">
            <SpriteIcon name={currency === 'RUBY' ? 'ruby' : 'gold'} color={currency === 'RUBY' ? '--Ruby-Dust' : '--Golden-Lock'} width={20} height={20} data-sentry-element="SpriteIcon" data-sentry-source-file="Currency.tsx" />
            <span>
            {formatWithSpaces(currentPrice)}
        </span>
        </div>;
};